import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-analysis-chart-widget',
  template: `
    <app-dashboard-card title="Assets in EICAssetMap" panelClass="dashboard-card--asset-analysis">
      <eic-asset-analysis-chart legendPosition="top"></eic-asset-analysis-chart>
    </app-dashboard-card>
  `
})
export class AssetAnalysisChartWidgetComponent { }
